import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const DETAILS = 'details';
export const PROPERTIES = 'properties';
export const DOCUMENTS = 'documents';
export const PRODUCTION = 'production';
export const SERIAL_NUMBERS = 'serial_numbers';
export const COMPONENTS = 'components';

export const tabs = [DETAILS, PROPERTIES, /* PRODUCTION, */ SERIAL_NUMBERS, /* COMPONENTS, */ DOCUMENTS];

export type AuthState = {
  currentTab: number;
};

const initialState: AuthState = {
  currentTab:
    tabs.indexOf(window.location.pathname.split('/').pop() || DETAILS) >= 0
      ? tabs.indexOf(window.location.pathname.split('/').pop() || DETAILS)
      : 0
};

const authSlice = createSlice({
  initialState,
  name: 'productDetailsTabs',
  reducers: {
    setTab: (state, { payload }: PayloadAction<number>) => ({ currentTab: payload })
  }
});

const { actions, reducer } = authSlice;
export const { setTab } = actions;

export { reducer as productFormTabs };
